import React from 'react';

import { QuestionButtonsField } from '../QuestionButtonsField';

export const QuestionYesNoField = (props) => {
  const buttons = [
    { value: 'Yes', text: 'questionnaire.buttons.Yes' },
    { value: 'No', text: 'questionnaire.buttons.No' }
  ];

  return (<QuestionButtonsField buttons={ buttons } { ...props } />);
};

QuestionYesNoField.displayName = 'QuestionYesNoField';

export default QuestionYesNoField;
